import React from "react";
import { useSelector } from "react-redux";

import FooterButton, { ProcessButton } from "./FooterButton";
import useNoteSaveHandlers from "../../hooks/useNoteSaveHandlers";

const ReportNoteButtons = ({ handleProcess }) => {
  const notes = useNoteSaveHandlers();

  const {
    isReportArchiving,
    isReportNoteSubmitting,
    isReportNoteSubmittingAndProcessing,
  } = useSelector((state) => state.transmission);

  return (
    <>
      <FooterButton
        kind="danger"
        label="Archive"
        dataAction="archive-button"
        onClick={notes.saveAndArchiveReportNote}
        isLoading={isReportArchiving}
      />

      <FooterButton
        kind="link"
        label="Save for Later"
        dataAction="save-for-later-button"
        onClick={notes.saveReportNote}
        isLoading={isReportNoteSubmitting}
      />

      <ProcessButton
        onClick={() =>
          notes.saveAndProcessReportNote() || handleProcess("process")
        }
        isLoading={isReportNoteSubmittingAndProcessing}
      />
    </>
  );
};

export default ReportNoteButtons;
